import { createClient } from 'graphql-ws';

import type { HttpOptions } from '@apollo/client';
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import React, { useMemo } from 'react';

import { canUseDOM } from '../utils';

interface Props {
  httpLinkUri: HttpOptions['uri'];
  wsLinkUrl?: string;
}

const getApolloClient = (httpLinkUri: Props['httpLinkUri'], wsLinkUrl: Props['wsLinkUrl']) => {
  let link = createHttpLink({ uri: httpLinkUri });

  if (canUseDOM && wsLinkUrl) {
    const wsLink = new GraphQLWsLink(createClient({ url: wsLinkUrl }));

    link = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      wsLink,
      link
    );
  }
  return new ApolloClient({ link, cache: new InMemoryCache() });
};

const ApolloClientProvider: React.FC<Props> = ({ children, httpLinkUri, wsLinkUrl }) => {
  const client = useMemo(() => getApolloClient(httpLinkUri, wsLinkUrl), [httpLinkUri, wsLinkUrl]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloClientProvider;
